<div class="w-full">
  <!--BLUE BAR-->
  <div class="horiz-bar bg-primary"></div>
  <!--TITLE-->
  <div class="flex justify-content-between align-items-center flex-wrap mb-4 mt-4">
    <div class="flex justify-content-between align-items-center">
      <div class="text-800 text-3xl font-medium mr-4">{{ 'SINGLE_MYOPE_TITLE' | translate }}</div>
      <div class="border-round-2xl px-2 py-1" [ngStyle]="{ backgroundColor: levelOfMyopiaColor, color: levelOfMyopiaTextColor }">
        {{ levelOfMyopia }}
      </div>
    </div>
    <p-dropdown
      [options]="dataSets"
      [(ngModel)]="selectedDataset"
      placeholder="Language"
      optionLabel="label"
      (onChange)="onDatasetChanged($event)">
    </p-dropdown>
  </div>
  <!--ROW 1-->
  <div class="grid grid-nogutter mb-4">
    <div class="col-6">{{ 'MYOPIA_SINGLE_VISIT_EVIDENCE_SUGGESTS' | translate }}</div>
    <div class="col-6 flex justify-content-between align-items-center">
      <div class="border-round-2xl px-2 py-1" [ngStyle]="{ backgroundColor: levelOfMyopiaColor, color: levelOfMyopiaTextColor }">
        {{ myopiaPredictionAt18 }}
      </div>
    </div>
  </div>

  <!--ROW 2-->
  <div class="mb-4 text-gray-400 text-sm">*{{ 'MYOPIA_SINGLE_VISIT_PREDICTION_EXPLAINER' | translate }}</div>
  <!--ROW 3-->
  <app-myopia-single-eim-retest
    [personalization]="undefined"
    [retestMonths]="retestPeriodsMonths"
    [singleMyopRiskAt18Result]="releventSingleMyopRiskAt18 ?? SingleMyopRiskAt18Result.HIGH"
    [ageAtLatestVisitInYears]="releventAge"
    [serAtLastVisit]="releventSerPredictedAt18!">
  </app-myopia-single-eim-retest>
  <div class="mb-4"></div>
</div>
